import { secondsToHM } from '@/utils/numberUtils'

export default {

  state: {
    editedSchedule: null
  },

  mutations: {

    clearEditedSchedule (state) {
      state.editedSchedule = null
    },

    initEditedSchedule (state) {
      state.editedSchedule = {
        selectedDaysOfWeek: new Set(),
        day: 0,
        hour: '07',
        minute: '00',
        playlist: null
      }
    },

    updateEditedSchedule (state, update) {
      const newSchedule = Object.assign({}, state.editedSchedule)
      if (update.key === 'playlist' && update.value) {
        update.value.hoursAndSeconds = secondsToHM(update.value.duration)
      }
      newSchedule[update.key] = update.value
      state.editedSchedule = newSchedule
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/scheduleEdit.js